import { useMemo, useContext, createContext } from 'react';

import { FORM_OTHER_OPTION_VALUE } from 'types';
import { randomizeChoiceOptions } from 'utils/randomize-choice-options';

// Without a course attempt (e.g. profile forms and previews), retain author order.
const CourseSubmissionContext = createContext<string | undefined>(undefined);
export const ChoiceRandomizationProvider = CourseSubmissionContext.Provider;

export function useChoiceOptions<T extends { value: string }>(
  questionId: string,
  enabled: boolean | undefined,
  options: readonly T[]
) {
  const submissionId = useContext(CourseSubmissionContext);
  return useMemo(
    () => [
      ...randomizeChoiceOptions(
        options,
        submissionId,
        questionId,
        enabled,
        FORM_OTHER_OPTION_VALUE
      ),
    ],
    [options, submissionId, questionId, enabled]
  );
}
